import * as types from '../constants';

export function confirmExtendSubscription(data) {
  return {
    type: types.CONFIRM_EXTEND_SUBSCRIPTION,
    data,
  };
}
